import type { PublicProduct } from '@/components/subscriptions/lib/public-product-catalog';

export type { PublicProduct, PublicProductPrice } from '@/components/subscriptions/lib/public-product-catalog';

export async function fetchPublicProducts(): Promise<PublicProduct[]> {
  const res = await fetch('/api/public/products');
  if (!res.ok) {
    throw new Error(`Failed to load products (${res.status})`);
  }
  return res.json();
}
